import { createSelector } from "reselect";
import getTextTrackLanguages from "selectors/captions/getTextTrackLanguages";

import find from "lodash/find";

const getDefaultCaptionLanguage = (state) =>
  state.playerOptions.defaultCaptionLanguage;
const getUserLanguages = (state) => state.device.browserLanguages;

const getDefaultTextTrackLanguage = createSelector(
  [getDefaultCaptionLanguage, getTextTrackLanguages, getUserLanguages],
  (defaultCaptionLanguage, textTracks, userLanguages) => {
    let lang = null;

    // url `language` param...
    lang = find(textTracks, {
      srclang: defaultCaptionLanguage, // set in the URL
    });

    // ...then prefer user's languages, in order of preference...
    userLanguages.forEach((userLanguage) => {
      lang =
        lang ||
        find(textTracks, {
          srclang: userLanguage, // browser language
        });
    });

    // ...otherwise use default track, english, or the first track.
    lang =
      lang ||
      find(textTracks, {
        default: true, // marked default in the data
      }) ||
      find(textTracks, {
        srclang: "en", // english
      }) ||
      textTracks[0] ||
      null; // just the first track available. then nothing.

    return lang;
  },
);

export default getDefaultTextTrackLanguage;
